import React from 'react';
import './SeasonSelector.css';

interface SeasonSelectorProps {
  selectedSeason: number;
  availableSeasons: number[];
  onSeasonChange: (season: number) => void;
  isLoading?: boolean;
}

const SeasonSelector: React.FC<SeasonSelectorProps> = ({ 
  selectedSeason, 
  availableSeasons, 
  onSeasonChange,
  isLoading = false 
}) => {
  return (
    <div className="season-selector">
      <label htmlFor="season-select" className="season-label">
        Select Season:
      </label>
      <div className="season-select-container">
        <select
          id="season-select"
          value={selectedSeason}
          onChange={(e) => onSeasonChange(parseInt(e.target.value))}
          disabled={isLoading}
          className="season-select"
        >
          {availableSeasons.map((season) => (
            <option key={season} value={season}>
              {season} Season
            </option>
          ))}
        </select>
        <div className="season-select-arrow">▼</div>
      </div>
    </div>
  );
};

export default SeasonSelector;